import React from 'react';
import { CheckCircle2, BellRing } from 'lucide-react';
import './SuccessToast.css';

export interface SuccessToastProps {
  visible: boolean;
  title: string;
  description: string;
  iconType?: 'success' | 'alert';
  zIndex?: number;
}

export function SuccessToast({ visible, title, description, iconType = 'success', zIndex = 9999 }: SuccessToastProps) {
  return (
    <div
      className={`success-toast-wrapper ${visible ? 'is-visible' : ''}`}
      style={{ zIndex }}
    >
      <div className={`success-toast-icon success-toast-icon-${iconType}`}>
        {iconType === 'success' ? <CheckCircle2 /> : <BellRing />}
      </div>
      <div className="success-toast-content">
        <p className="success-toast-title">{title}</p>
        <p className="success-toast-desc">{description}</p>
      </div>
    </div>
  );
}
